module.exports = __webpack_public_path__ + "ea7825a471ee558362eb2e2bdc072ae4.pdf";